class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
		this.debouncedOnSubmit = debounce((event) => {
			this.onSubmitHandler(event);
		}, 500);
		this.gridElements = document.querySelectorAll('.product-grid-item');
		this.filterCheckboxes = this.querySelectorAll('.mobile-facets__item');
		this.viewResults = this.querySelector('.facets-view-results');
		const facetForm = this.querySelector('form');
		facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
	}

	resultsUpdate() {
		const gridNotHiddenElements = document.querySelectorAll('.product-grid-item:not(.hidden)');
		this.viewResults.textContent = `View Results (${gridNotHiddenElements.length})`;
	}

	onSubmitHandler(event) {
		event.preventDefault();
		this.gridElements = document.querySelectorAll('.product-grid-item');
		const sortFilterForms = document.querySelectorAll('facet-filters-form form');
		if (event.srcElement.className == 'mobile-facets__checkbox') {
			const searchParams = this.createSearchParams(event.target.closest('form'));
			console.log("initial search param: ", searchParams);
			this.onSubmitForm(searchParams, event)
		} else {
			const forms = [];
			const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
			sortFilterForms.forEach((form) => {
				if (!isMobile) {
					if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
						forms.push(this.createSearchParams(form));
					}
				} else if (form.id === 'FacetFiltersFormMobile') {
					forms.push(this.createSearchParams(form));
				}
			});
			this.onSubmitForm(forms.join('&'), event)
		}
	}

	createSearchParams(form) {
		const formData = new FormData(form);
		return new URLSearchParams(formData).toString();
	}

	onSubmitForm(searchParams, event) {
		console.log("search param is: ", searchParams);
		this.updateURLHash(searchParams);
		let colorValues = this.getColorValue();
		let sizeValues = this.getSizeValue();
		if (colorValues.length > 0 || sizeValues.length > 0) {
			this.hideGridElements();
			this.showActiveGridElements(colorValues, sizeValues.join('.'));
			this.resultsUpdate();
		} else {
			this.showAllGridElements();
			this.resultsUpdate();
		}
	}

	getColorValue() {
		const params = new URLSearchParams(window.location.search)
		return params.getAll('color');
	}

	getSizeValue() {
		const params = new URLSearchParams(window.location.search)
		return params.getAll('size');
	}

	updateURLHash(searchParams) {
		history.pushState({
			searchParams
		}, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
		console.log("new url is: ", {
			searchParams
		}, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`)
	}

	hideGridElements() {
		console.log('aya idr');
		collectionGrid.classList.remove('loading');
		this.gridElements.forEach(el => {
			el.classList.add('hidden');
		});
		if (document.querySelector('.clp-promo-banner')) {
			document.querySelectorAll('.clp-promo-banner').forEach(promo => {
				// promo.classList.add('hidden');
			});
		}
	}

	showAllGridElements() {
		this.gridElements.forEach(el => {
			el.classList.remove('hidden');
		});

		if (document.querySelector('.clp-promo-banner')) {
			document.querySelectorAll('.clp-promo-banner').forEach(promo => {
				// promo.classList.remove('hidden');
			});
		}
	}

	showActiveGridElements(colorValues, sizeValues) {
		colorValues.forEach(colorValue => {
			document.querySelectorAll('.product-grid-item').forEach(gridEl => {
				if (gridEl.querySelector('.product-card').classList.contains(`${colorValue}`)) {
					gridEl.classList.remove('hidden');
				}
			})
		})

		if (colorValues.length > 0) {
			if (sizeValues != '') {
				document.querySelectorAll('.product-grid-item:not(.hidden)').forEach(gridEl => {
					if (!gridEl.querySelector(`.${sizeValues}`)) {
						gridEl.classList.add('hidden');
					}
				})
			}
		} else {
			document.querySelectorAll('.product-grid-item').forEach(gridEl => {
				if (gridEl.querySelector(`.${sizeValues}`)) {
					gridEl.classList.remove('hidden');
				}
			})
		}
	}

	updateURLHashDelete() {
		history.pushState({}, '', `${window.location.pathname}`);
	}

	updateCheckboxStates(filterCheckboxes, filtersApplied, statusCheck) {
		filterCheckboxes.forEach(item => {
			let input = item.querySelector('.mobile-facets__checkbox');
			let inputValue = input.value;
			if (statusCheck) {
				filtersApplied.forEach(filter => {
					if (filter === inputValue) {
						input.setAttribute('checked', true);
						item.classList.add('active');
					}
				});
			} else {
				input.checked = false;
				item.classList.remove('active');
			}
		});
		this.resultsUpdate();
	}

	onActiveFilterClick(event) {
		event.preventDefault();
		FacetFiltersForm.toggleActiveFacets();
		const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
		this.updateURLHash(url);
		this.showAllGridElements();
		this.updateCheckboxStates(this.filterCheckboxes, null, false)
	}

	static toggleActiveFacets(disable = true) {
		// document.querySelectorAll('.js-facet-remove').forEach((element) => {
		//   element.classList.toggle('disabled', disable);
		// });
	}
}

FacetFiltersForm.filterData = [];
customElements.define('facet-filters-form', FacetFiltersForm);

class FacetRemove extends HTMLElement {
	constructor() {
		super();
		const facetLink = this.querySelector('a');
		facetLink.setAttribute('role', 'button');
		facetLink.addEventListener('click', this.closeFilter.bind(this));
		facetLink.addEventListener('keyup', (event) => {
			event.preventDefault();
			if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
		});
	}

	closeFilter(event) {
		event.preventDefault();
		const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
		form.onActiveFilterClick(event);
	}
}

customElements.define('facet-remove', FacetRemove);

// Adjust filter drawer position on scroll
const headerEl = document.getElementById("shopify-section-header");
const facetsForm = document.getElementById("FacetFiltersFormMobile");
const collcetionGridOffset = document.getElementById("ProductGridContainer").offsetTop;
const collectionGrid = document.getElementById("ProductGridContainer");
const filterCloseBtn = document.querySelector(".mobile-facets__close");
const categoriesbar = document.querySelector(".sub-categories");
const filterOpenBtn = document.querySelector(".mobile-facets__open");
const searchPageHeader = document.querySelector(".template-search__header");

const filderDrawerPosition = () => {
	var currPosition = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
	var winWidth = window.outerWidth;
	var filtersDrawer = document.querySelector(".mobile-facets__disclosure");

	if (currPosition == 0) {
		document.querySelector(".facets-container-drawer").style.cssText = "z-index: 1";

	} else {
		if (currPosition > 20) {
			if (winWidth > 749 && filtersDrawer.classList.contains("menu-opening")) {
				filterCloseBtn.click();
			}
		}
	}
}


const filterDrawerIndexing = () => {
	filderDrawerPosition();
	$("#shopify-section-header").addClass("transform-for-search");
}

filterCloseBtn.addEventListener("click", () => {
	$("#shopify-section-header").removeClass("transform-for-search");
});

document.addEventListener("scroll", filderDrawerPosition);
filterOpenBtn.addEventListener("click", filterDrawerIndexing);
window.addEventListener('resize', filderDrawerPosition, true);
filderDrawerPosition();


const filterHeaders = Array.from(document.querySelectorAll(".filter-header"));
filterHeaders.forEach(node => {
	node.addEventListener("click", (e) => {
		let el = event.target;
		el.closest(".accordion-section").classList.toggle("accordion-section--expanded");

		if ($(el).next(".mobile-facets__list").find(".mobile-facets__label").attr("tabindex")) {
			$(el).next(".mobile-facets__list").find(".mobile-facets__label").removeAttr("tabindex");
		} else {
			$(el).next(".mobile-facets__list").find(".mobile-facets__label").attr("tabindex", 1);
		}

		if (el.closest(".accordion-section").getAttribute("aria-expanded") == "true") {
			el.closest(".accordion-section").setAttribute("aria-expanded", "false");
		} else {
			el.closest(".accordion-section").setAttribute("aria-expanded", "true");
		}
	});

	// Open accordion on pressing enter
	node.addEventListener("keypress", function(event) {
		let el = event.target;
		// If the user presses the "Enter" key on the keyboard
		if (event.key === "Enter") {
			// Cancel the default action, if needed
			event.preventDefault();
			el.click();
		}
	});
});

const filterBtns = Array.from(document.querySelectorAll(".mobile-facets__label"));

filterBtns.forEach(node => {
	node.addEventListener("keypress", function(event) {
		let el = event.target;

		if (event.key === "Enter") {
			// Cancel the default action, if needed
			event.preventDefault();
			// Trigger the button element with a click
			el.click();
		}
	});
});

$('.mobile-facet-Color').each(function() {
	if ($(this).find(".color-swatch").length < 1) {
		$(this).hide();
	}
});